import React from 'react';
import TextField from '../../../../Forms/TextField';
import ChoiceGroup from '../../../../Forms/ChoiceGroup';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import Toggle from "../../../../Forms/Toggle";
import { Text } from "@fluentui/react";
import FluentSelect from "../../../../Forms/FluentSelect";

const statOptions = [
    { key: 0, text: 'Off' },
    { key: 1, text: 'On' },
];

const ProgramForm = ({ model }) => {
    return (
        <div className="mt-1">
            <ChoiceGroup label="US On/Off" name="onOffDefault" options={statOptions} />
            <Toggle
                name="internationalOn"
                label="Program International On/Off Setting"
                onText="Program is on for all countries"
                offText="Program is only seen in the United States"
                css={css`margin-top: 20px;`}
            />
            {model.internationalOn && ( 
            <div css={css`margin-top: 20px;`} >
                <ChoiceGroup 
                    label="Program Localization Setting" 
                    name="isGlobal" 
                    options={statOptions} 
                    required
                />
                <Text variant="small">
                    If the program is {model.isGlobal ? "on" : "off"} globally, then you can
                    set the exceptions below.
                </Text>
                <FluentSelect
                    label={model.isGlobal ? "Hide From" : "Show To"}
                    options={model.countries}
                    isMulti
                    name={model.isGlobal ? 'excludeCountries' : 'includeCountries'}
                    menuPlacement="auto"
                />
            </div>
            )}
        </div>
    );
};

export default ProgramForm;
